import axios, { type InternalAxiosRequestConfig } from "axios";

export const API = "https://www.absolutions.dev";

const $api = axios.create({
  withCredentials: false,
  baseURL: `${API}/api`,
});

$api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const acceptLanguage = config.headers?.["accept-language"];
  const language = acceptLanguage || "en,en-US;q=0.9,uk;q=0.8,ru;q=0.7";
  config.headers["accept-language"] = language;
  return config;
});

$api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default $api;
